



























































import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalDelete from '@/components/modals/ModalDelete.vue';
import {
  CollectionItem,
  CollectionItemType,
  INITIAL_OBJECTIVE_LABEL,
  INITIAL_SUBJECTIVE_LABEL,
} from '@/resource/collection-item/collection-item.model';
import ComponentCollectionItem from '@/components/collection-items/collection-item-component/ComponentCollectionItem.vue';

@Component({
  components: {
    ModalDelete,
    ComponentCollectionItem,
  },
})
export default class CollectionItemContainer extends Vue {
  @Prop()
  collectionItem!: CollectionItem;

  @Prop({ default: false })
  showRearrangePositions: boolean;

  @Prop()
  fetchQuestions!: () => void;

  @Prop()
  totalQuestions!: number;

  @Prop()
  totalFetchQuestions!: number;

  @Prop()
  totalSubjectiveQuestions!: number;

  @Prop()
  lastObjectiveQuestion!: number;

  @Prop()
  itemIndex!: number;

  @Prop()
  moveCollectionItem!: (fromIndex: number, toIndex: number) => void;

  showDeleteItem = false;
  deleteTitle = 'Delete question';
  deleteDescription = `Are you sure you want to delete this question from this collection?`;

  basedArrowClass = `mb-10 w-30 h-30 flex justify-center items-center rounded`;

  get showItem() {
    if (this.collectionItem.questionPosition === INITIAL_OBJECTIVE_LABEL) {
      return this.lastObjectiveQuestion === 0 ? false : true;
    } else if (
      this.collectionItem.questionPosition === INITIAL_SUBJECTIVE_LABEL
    ) {
      return this.totalSubjectiveQuestions === 0 ? false : true;
    } else {
      return true;
    }
  }

  get isTitleItem() {
    return this.collectionItem.collectionItemType === CollectionItemType.Title;
  }

  get isObjective() {
    return (
      this.collectionItem.collectionItemType === CollectionItemType.Objective
    );
  }

  get correctPosition() {
    if (this.isObjective) {
      return this.itemIndex;
    } else {
      return this.itemIndex - 1;
    }
  }

  get isLastItem() {
    const isLastObjective =
      this.collectionItem.questionPosition === this.lastObjectiveQuestion;

    const isLastSubjective = this.itemIndex + 1 === this.totalFetchQuestions;

    return isLastObjective || isLastSubjective;
  }

  get isFirstItem() {
    const isFirstObjective = this.itemIndex === 1;
    const isFirstSubjective = this.itemIndex === this.lastObjectiveQuestion + 1;
    const isFirstSubjectiveAndNoObjective =
      this.itemIndex === 2 && this.lastObjectiveQuestion === 0;

    return (
      isFirstObjective || isFirstSubjective || isFirstSubjectiveAndNoObjective
    );
  }

  get classArrowUp() {
    return this.isFirstItem
      ? `${this.basedArrowClass} bg-gray-300 cursor-not-allowed`
      : `${this.basedArrowClass} bg-red-100 hover:bg-red-200`;
  }

  get classArrowDown() {
    return this.isLastItem
      ? `${this.basedArrowClass} bg-gray-300 cursor-not-allowed`
      : `${this.basedArrowClass} bg-red-100 hover:bg-red-200`;
  }

  arrowUpClicked() {
    if (this.isFirstItem) return;
    const fromIndex = this.itemIndex;
    const toIndex = fromIndex - 1;

    this.moveCollectionItem(fromIndex, toIndex);
  }

  arrowDownClicked() {
    if (this.isLastItem) return;

    const fromIndex = this.itemIndex;
    const toIndex = fromIndex + 1;

    this.moveCollectionItem(fromIndex, toIndex);
  }

  deleteItemClicked() {
    this.showDeleteItem = true;
  }

  closeItemDelete(isDeleted = false) {
    if (isDeleted) {
      this.fetchQuestions();
    }
    this.showDeleteItem = false;
  }
}
